import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=071bdd0c&scoped=true&"
import script from "./ItemDetail.vue?vue&type=script&lang=ts&"
export * from "./ItemDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=071bdd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071bdd0c",
  null
  
)

export default component.exports